import { CardPaymentsTableSortableField } from 'types/state';
import { M8PaymentTransactionDTOSortableField } from 'services/production/types';
import { UnreachableError } from 'utils/errors';

export const normalizeCardPaymentsTableSortableField = (
  field: CardPaymentsTableSortableField
) => ({
  toM8PaymentTransactionDTOSortableField(): M8PaymentTransactionDTOSortableField {
    switch (field) {
      case 'id':
        return 'id';
      case 'organization':
        return 'user.organization';
      case 'fullName':
        return 'user.lastName';
      case 'recievedAmount':
        return 'amount';
      case 'creditedAmount':
        return 'billedAmount';
      case 'status':
        return 'paymentTransactionStatus';
      case 'createdAt':
        return 'createdOn';
      case 'updatedAt':
        return 'updatedOn';
      default:
        throw new UnreachableError(field);
    }
  },
});
